/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const Explore: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M19.5 8.25165H17C16.0775 8.25165 15.2783 8.75831 14.8458 9.50165H12V8.25165H7V9.50165H3.25C2.56 9.50165 2 10.0616 2 10.7516V14.5016C2 15.1933 2.56 15.7516 3.25 15.7516H14.8458C15.2783 16.4966 16.0758 17.0016 17 17.0016H22V8.25165H19.5ZM8.25 9.50165H10.75V10.7516H8.25V9.50165ZM14.5 14.5016H3.875C3.53 14.5016 3.25 14.2216 3.25 13.8766V11.3766C3.25 11.0316 3.53 10.7516 3.875 10.7516H7V12.0016H12V10.7516H14.5V14.5016ZM18.25 15.7516H17C16.3083 15.7516 15.75 15.1925 15.75 14.5016V10.7516C15.75 10.0616 16.3083 9.50165 17 9.50165H18.25V15.7516ZM20.75 15.7516H19.5V9.50165H20.75V15.7516Z" />

    </StyledIconBase>
  )
})

Explore.displayName = 'Explore'

export const ExploreDimensions = {height: 24, width: 24}
